import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["VChart"], {
    ref: "chart",
    class: "chart",
    option: $setup.option,
    autoresize: ""
  }, null, 8 /* PROPS */, ["option"]))
}